const SurveyConst = {
  SET_AGE: "SET_AGE",
  SET_GENDER: "SET_GENDER",
  SET_HAS_DEGREE: "SET_HAS_DEGREE",
  SET_DEGREE: "SET_DEGREE",
  SET_LANGUAGE_NATIVE: "SET_LANGUAGE_NATIVE",
  SET_LANGUAGE: "SET_LANGUAGE",
  SET_TESTS: "SET_TESTS",
  SET_FEEDBACK_TEXT: "SET_FEEDBACK_TEXT",
  SAVE_SURVEY: "SAVE_SURVEY",
  TRIGGER_SURVEY_FORM: "TRIGGER_SURVEY_FORM",
  SET_SURVEY_VALUE: "SET_SURVEY_VALUE",
  SURVEY_CLICK: "SURVEY_CLICK"
};
export default SurveyConst;



// WEBPACK FOOTER //
// ./src/modules/survey/SurveyConst.js